import React from "react"
import './ColorNumber.scss'
import Typography from "@mui/material/Typography";

const ColorNumber = ({number, endSign, typographyVariant, fontWeight = 600, className, includeBrackets = false}) => {
    const cleanedStringToNumber = number.replace('%', '');
    const isNumber = !isNaN(parseFloat(cleanedStringToNumber))
    if (isNumber) {
        const floatNumber = +cleanedStringToNumber
        const numberWithAdditionalSigns = includeBrackets ? `(${floatNumber} ${endSign && endSign})` : `${floatNumber} ${endSign && endSign}`

        return (
            <div className={floatNumber === 0 ? '' : (floatNumber > 0 ? "colorBlue" : "colorRed")}>
                {className ? <div className={className}>
                    {numberWithAdditionalSigns}
                </div> : <Typography variant={typographyVariant} sx={{fontWeight: fontWeight}}>
                    {numberWithAdditionalSigns}
                </Typography>
                }

            </div>
        )
    }
    return (
        <>
            NaN
        </>
    )
}

export default ColorNumber